import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import e from "express";

@Component({
  selector: "app-milestone-common-check-box",
  templateUrl: "./milestone-common-check-box.component.html",
  styleUrls: ["./milestone-common-check-box.component.css"],
})
export class MilestoneCommonCheckBoxComponent implements OnInit {
  constructor() {}

  filter = {
    label: "",
  };
  selectedData = [];
  selectedIds = []; // Stores only selected IDs
  previousData = [];

  @Input() dataList;
  @Input() type: string;
  @Input() isEdit: boolean;
  @Input() selected: any;
  @Input() isMultiple: boolean = true;
  @Output() dataSelected = new EventEmitter<any>();

  resetFilter() {
    this.filter.label = "";
  }
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataList && this.dataList?.length) {
      this.updateSelectedData();
      this.onSelectionChange();
    }
  }

  updateSelectedData(): void {
    if (this.isEdit && this.isMultiple) {
      this.selectedData = this.dataList.filter((item) =>
        this.selected?.includes(item.id)
      );
      this.selectedIds = this.selected
    }
    if (this.isEdit && !this.isMultiple) {
      this.selectedData = this.selected;
    }
  }

  isSelected(val: any): boolean {
    return this.selectedData.some((selected) => {
      return selected.id === val.id;
    });
  }

  onSelectionChange() {
    if (this.isMultiple) {
      this.selectedData = this.dataList.filter((item) =>
        this.selectedIds?.includes(item.id)
      );
      this.selectedIds = this.selectedData.map((val) => val.id);
      console.log("Selected Objects:", this.selectedData);
      console.log("Selected IDs:", this.selectedIds);
      this.dataSelected.emit(this.selectedIds);
    } else{
      this.dataSelected.emit(this.selectedData);
    }
  }

  onDataChange(event){
    console.log(event)
    // this.selectedData = this.dataList.filter((item) =>
    //   this.selectedIds?.includes(item.id)
    // );
    if(event.source.selected && event.isUserInput){
      let index = this.selectedData.findIndex((item) => item.id === event.source.value.id);
      if (index === -1) {
      this.selectedData.push(event.source.value);
      this.selectedIds = this.selectedData.map((val) => val.id);
      console.log("Selected Objects:", this.selectedData);
      console.log("Selected IDs:", this.selectedIds);
      }
    } else if(!event.source.selected && event.isUserInput){
      let index = this.selectedData.findIndex((item) => item.id === event.source.value.id);
      if (index !== -1) {
        this.selectedData.splice(index, 1);
        this.selectedIds = this.selectedData.map((val) => val.id);
        console.log("Selected Objects:", this.selectedData);
        console.log("Selected IDs:", this.selectedIds);
      }
      
    }
  }
}
